import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { ROUTES } from '@/constants/routes';

export const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[70vh] w-full flex-col items-center justify-center p-6 text-center">
      <div className="rounded-full bg-destructive/10 p-4 text-destructive shadow-xs">
        <ShieldAlert className="h-10 w-10" />
      </div>
      <h1 className="mt-4 text-2xl font-bold tracking-tight text-foreground">403 — Access Restricted</h1>
      <p className="mt-1 max-w-md text-xs text-foreground-secondary leading-relaxed">
        Your current role does not have authorization to view this enterprise resource. If you believe this is an error, please contact your system administrator.
      </p>
      <div className="mt-6 flex items-center gap-3">
        <Button variant="outline" size="sm" onClick={() => navigate(-1)}>
          <ArrowLeft className="h-4 w-4 mr-1.5" /> Go Back
        </Button>
        <Button size="sm" onClick={() => navigate(ROUTES.DASHBOARD)}>
          <Home className="h-4 w-4 mr-1.5" /> Return to Dashboard
        </Button>
      </div>
    </div>
  );
};
